import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import VentesDetailleesPage from "./pages/VentesDetailleesPage";
import AdminPage from "./pages/AdminPage";
import AdminUsersPage from "./pages/AdminUsersPage";
import SetPasswordPage from "./pages/SetPasswordPage";
import EffectifsPage from "./pages/EffectifsPage";
import BankAccountsPage from "./pages/BankAccountsPage";
import InformationsPage from "./pages/InformationsPage";
import MarketingPage from "./pages/MarketingPage";
import ExploitationPage from "./pages/ExploitationPage";
import KPIPage from "./pages/KPIPage";
import BriefingPage from "./pages/BriefingPage";
import AdminImportPage from "./pages/AdminImportPage";

// Protected Route component
const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();
    
    if (loading) {
        return (
            <div className="h-screen flex items-center justify-center bg-background">
                <div className="text-center">
                    <div className="w-16 h-16 bg-primary rounded-xl flex items-center justify-center mx-auto mb-4 animate-pulse">
                        <span className="text-primary-foreground text-2xl font-heading font-bold">R</span>
                    </div>
                    <p className="text-muted-foreground">Chargement...</p>
                </div>
            </div>
        );
    }
    
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }
    
    return children;
};

// Route protégée pour admin uniquement
const AdminRoute = ({ children }) => {
    const { isAuthenticated, loading, isAdmin } = useAuth();
    
    if (loading) {
        return (
            <div className="h-screen flex items-center justify-center bg-background">
                <div className="text-center">
                    <div className="w-16 h-16 bg-primary rounded-xl flex items-center justify-center mx-auto mb-4 animate-pulse">
                        <span className="text-primary-foreground text-2xl font-heading font-bold">R</span>
                    </div>
                    <p className="text-muted-foreground">Chargement...</p>
                </div>
            </div>
        );
    }
    
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }
    
    if (!isAdmin) {
        return <Navigate to="/dashboard" replace />;
    }
    
    return children;
};

// App Routes
const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/set-password" element={<SetPasswordPage />} />
            <Route 
                path="/dashboard" 
                element={
                    <ProtectedRoute>
                        <DashboardPage />
                    </ProtectedRoute>
                } 
            />
            <Route 
                path="/ventes-detaillees" 
                element={
                    <ProtectedRoute>
                        <VentesDetailleesPage />
                    </ProtectedRoute>
                } 
            />
            <Route 
                path="/admin" 
                element={
                    <ProtectedRoute>
                        <AdminPage />
                    </ProtectedRoute>
                } 
            />
            <Route 
                path="/admin/users" 
                element={
                    <ProtectedRoute>
                        <AdminUsersPage />
                    </ProtectedRoute>
                } 
            />
            <Route 
                path="/effectifs" 
                element={
                    <ProtectedRoute>
                        <EffectifsPage />
                    </ProtectedRoute>
                } 
            />
            <Route 
                path="/bank" 
                element={
                    <ProtectedRoute>
                        <BankAccountsPage />
                    </ProtectedRoute>
                } 
            />
            <Route 
                path="/bank/callback" 
                element={
                    <ProtectedRoute>
                        <BankAccountsPage />
                    </ProtectedRoute>
                } 
            />
            <Route 
                path="/informations" 
                element={
                    <ProtectedRoute>
                        <InformationsPage />
                    </ProtectedRoute>
                } 
            />
            <Route 
                path="/marketing" 
                element={
                    <ProtectedRoute>
                        <MarketingPage />
                    </ProtectedRoute>
                } 
            />
            <Route 
                path="/briefing" 
                element={
                    <ProtectedRoute>
                        <BriefingPage />
                    </ProtectedRoute>
                } 
            />
            <Route 
                path="/exploitation" 
                element={
                    <ProtectedRoute>
                        <ExploitationPage />
                    </ProtectedRoute>
                } 
            />
            <Route 
                path="/kpi" 
                element={
                    <ProtectedRoute>
                        <KPIPage />
                    </ProtectedRoute>
                } 
            />
            <Route 
                path="/admin-import" 
                element={
                    <AdminRoute>
                        <AdminImportPage />
                    </AdminRoute>
                } 
            />
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
    );
};

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <AppRoutes />
                <Toaster richColors position="top-right" />
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
